import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import GrammatechCodeSonarConfigListing from './GrammatechCodeSonarConfigListing'
import GrammatechCodeSonarCredentialForm from './GrammatechCodeSonarCredentialForm'

export default function GrammatechCodeSonarPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={GrammatechCodeSonarCredentialForm}
            PullConfigListingView={GrammatechCodeSonarConfigListing}
        />
    )
}
